import { render } from "./MbPurchaseStartedatCaution.vue?vue&type=template&id=2d1e173a&scoped=true"
import script from "./MbPurchaseStartedatCaution.vue?vue&type=script&lang=js"
export * from "./MbPurchaseStartedatCaution.vue?vue&type=script&lang=js"

import "./MbPurchaseStartedatCaution.vue?vue&type=style&index=0&id=2d1e173a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d1e173a"

export default script